


import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

import formatDate from '@/shared/filters/formatDate.filter.ts';
import uppercase from '@/shared/filters/uppercase.filter.ts';
import UtilsService from '@/core/services/utils.service';
import Assets from '@/constants/assets.ts';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';

import { Note } from '@/manager/convocation/note.model';
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';
import Btn, { BtnColor, BtnPredefinedStyle, BtnWidth } from '@/shared/components/btn.component.vue';
import { BudgetAlertLiteral } from '@/manager/budget/models/budget.model';
import FlatSelectorTextMultiple from '@/shared/components/FlatSelectorTextMultiple.component.vue';
import SelectTag from '@/shared/components/select.tag.component.vue';
import ClientService from '@/manager/client/client.service';
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';

@Component({
    components: {
        Icon,
        Btn,
        FlatSelectorTextMultiple,
        Modal,
        TextArea,
        SelectTag,
        SearchAutocomplete
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            getConvocationNote: 'getConvocationNote',
            getParticipantNote: 'getParticipantNote',
            getParticipantNotes: 'getParticipantNotes',
            clientList: "getClientList"
        }),
    },
    methods: {
        ...mapActions({
            fetchEmployeeList: 'fetchEmployeeList',
        }),
        updateComment(commentId: any, comment: any) {
            this.$emit('note-item-update', commentId, comment);
        }
    },
    filters: {
        formatDate,
        uppercase,
    },
})
export default class NoteItem extends Vue {
    @Prop() private noteId!: string;
    @Prop() private elementId!: string;
    @Prop() private employeeId!: string;
    @Prop({ default: 'convocation' }) private type!: string;

    private assets = Assets;
    private iconEnum = IconEnum;
    private getConvocationNote!: any;
    private getParticipantNote!: any;
    private getParticipantNotes!: any;
    private getProfile!: any;
    private updatingTime = 1000;
    private updateTimeout!: any;
    private utilsService = UtilsService;
    private btnWidth = BtnWidth;
    private btnColor = BtnColor;
    private budgetAlertLiteral = BudgetAlertLiteral;
    private btnPredefinedClass = BtnPredefinedStyle;
    private modalTitleColor = ModalTitleColor;
    private deleteBudgetModalOpened = false;
    private addObservationBudgetModalOpened = false;
    private modalNoteEmpty = false;
    private modalNote = "";
    private addCommentModalOpened = false;
    private modalCommentEmpty = false;
    private modalComment = "";
    private notifications = [];
    private employeeList = [];
    private fetchEmployeeList !: any;
    private employeeEmails = [];
    private isUpdated = false;
    private searchString = "";
    private getClient!: any;
    private selectedClient!: any;
    private getSelectedClient!: any;
    private searchClient: any = false;
    private mentions: any = [];
    private searchTimeout: any = null

    @Watch('noteContent')
    public watchNoteContent(newVal: string, oldVal: string) {
        this.isUpdated = true;
        if (newVal.slice(-1) == "$") {
            this.searchClient = true;
        } else {
            this.searchClient = false;
        }
        // clearTimeout( this.updateTimeout );
        // this.updateTimeout = setTimeout(() => {
        //     if ( this.note.note !== '' ) {
        //         this.$emit( 'note-item-update', this.note.id, this.note.note );
        //     }
        // }, this.updatingTime);
    }

    @Watch("searchString")
    public watchsearchString(newVal: any, oldVal: any) {
        if (newVal && newVal.length > 3 && !this.selectedClient) {
            if (this.searchTimeout != null) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.searchCallback();
            }, 1000);
        }
    }

    @Watch("getSelectedClient")
    public watchGetSelectedClient(newVal: any, oldVal: any) {
        if (newVal) {
            // this.selectClient(newVal);
        }
    }

    public saveNote() {
        // clearTimeout( this.updateTimeout );
        // this.updateTimeout = setTimeout(() => {
        if (this.note.note !== '') {
            this.$emit('note-item-update', this.note.id, this.note.note, false, this.note.mentions);
            this.isUpdated = false;
        }
        // }, this.updatingTime);
    }

    private created() {
        this.fetchEmployeeEmails();
    }

    private fetchEmployeeEmails() {
        let payload = {
            limit: 1000
        }
        this.$store.dispatch("fetchEmployeeList", payload).then((res) => {
            this.employeeList = res.results.map((e: any) => {
                return {
                    name: e.user.fullName,
                    email: e.user.email,
                    id: e.user.id,
                };
            });
        });
    }

    private async selectClient(option: any) {
        this.selectedClient = option;
        this.searchClient = false;
        // console.log(this.selectedClient);
        this.note.note += this.selectedClient.text;
        this.note.mentions.push(this.selectedClient)
    }

    private setIsPostponement(isPostponement: any, id: any) {
        // this.purchase.requestReturn = status;
        // console.log(isPostponement);
        this.$emit('note-item-update', this.note.id, this.note.note, isPostponement);
    }

    private clearClient() {
        this.selectedClient = null;
    }

    private updateComment(commentId: any, comment: any) {
        // this.$emit( 'note-item-update', commentId, comment );
        const payload = {
            elementId: this.elementId,
            commentId: commentId,
            noteId: this.noteId,
            data: { comment: comment, employeeModified: this.employeeId, isEdited: true },
        };
        this.$store.dispatch("patchBudgetCommentNote", payload);

        // this.$store.dispatch("patchBudgetCommentNote", payload).then((res: any) => {
        //     this.$emit( 'comment-note-item-delete' );
        // });
    }

    public searchCallback() {
        if (this.searchString === "") {
            this.selectedClient = null;
        }
        this.fetchClientList();
    }

    private fetchClientList() {
        const payload = {
            limit: 20,
            search: this.searchString
        };
        this.$store.dispatch("fetchClientList", payload);
    }

    private sendNotificationsNoteEmail(value: boolean) {
        this.addObservationBudgetModalOpened = value;

        let emails = this.employeeEmails.map((employee:any) => employee['email']);
        let data = {
            'sender': this.getProfile.fullName,
            'from': this.getProfile.email,
            'emails': emails,
            'id': this.note.id,
            'content': this.note.note,
            'date': this.note.created,
            'creator': (this.note.employee ? this.note.employee.user.fullName : 'Usuario desconocido')
        }
        ClientService.sendNotificationsNote(data)
        // .then(this.onSucess, this.onError);
    }

    private toggleBudgetObservationModalOpened(value: boolean) {
        // sendNotifications(note.id)

        this.addObservationBudgetModalOpened = value;
        // this.sendNotificationsNoteEmail();
    }

    // private sendNotifications(value: boolean) {
    //     // sendNotifications(note.id)

    //     this.addObservationBudgetModalOpened = value;
    //     this.sendNotificationsNoteEmail();
    // }

    // private toggleBudgetObservationModalOpened(value: boolean) {
    //     // sendNotifications(note.id)
    //     console.log(value);
    //     this.addObservationBudgetModalOpened = value;
    // }

    private toggleCommentModalOpened(value: boolean) {
        this.addCommentModalOpened = value;
    }

    get note() {
        let result;
        if (this.type === 'convocation') {
            result = this.getConvocationNote(this.noteId);
        } else if (this.type === 'participant') {
            result = this.getParticipantNote(this.noteId);
        } else if (this.type !== 'convocation' && this.type !== 'participant') {
            const getter = this.type;
            result = this.$store.getters[getter](this.noteId);
        }
        return result;
    }

    get noteContent() {
        return this.note.note;
    }

    get modalNotePlaceholder() {
        let placeholder =
            "Comparte alguna observación con tus compañeros sobre esta alta...";
        if (this.modalNoteEmpty) {
            placeholder = "Este campo no puede estar vacío...";
        }
        return placeholder;
    }

    get modalCommentPlaceholder() {
        let placeholder =
            "Comparte algún comentario con tus compañeros sobre la nota de esta alta...";
        if (this.modalCommentEmpty) {
            placeholder = "Este campo no puede estar vacío...";
        }
        return placeholder;
    }

    private addComment(noteId: any) {
        // console.log(this.type);
        // console.log(this.elementId);
        if (this.modalComment.length === 0) {
            this.modalCommentEmpty = true;
        } else {
            this.addCommentModalOpened = false;
            // this.requestShowSpinner();
            this.$store
                .dispatch("newBudgetCommentNote", {
                    elementId: this.elementId,
                    noteId: noteId,
                    employee: { user: { id: this.employeeId } },
                    comment: this.modalComment,
                })
                .then((res) => {
                    this.$emit('comment-note-item-delete');
                    // this.resetModalNoteEmpty(true);
                    // this.fetchBudgetNotes(this.elementId);
                    // // this.changeSpinnerVisibility(false);
                    // this.refetchBudget(this.elementId);
                });
        }
    }

    private fetchBudgetNotes(budgetId: any) {
        // this.requestShowSpinner();
        this.$store
            .dispatch("fetchBudgetNotes", { id: budgetId })
            .then((res) => {
                this.$emit('comment-note-item-delete');
                // this.changeSpinnerVisibility(false);
                // if (!this.yetOpenedCollapsableInfo) {
                // this.yetOpenedCollapsableInfo = true;
                // }
            });
    }

    private refetchBudget(budgetId: any) {
        this.$store.dispatch("fetchBudget", { id: budgetId });
    }

    private resetModalNoteEmpty(force: boolean) {
        if (force || this.modalNote === "") {
            this.modalNoteEmpty = false;
            this.modalNote = "";
        }
    }

    get me() {
        return (
            this.note.employee &&
            this.note.employee.user &&
            this.getProfile.id === this.note.employee.user.id
        );
    }

    get allMe() {
        return (
            this.note.employee &&
            this.note.employee.user &&
            this.getProfile.id === this.note.employee.user.id && (!this.note.noteComment || this.onlyMyComments(this.note.noteComment))
        );
    }

    private onlyMyComments(comments: any) {
        var onlyMyComments = true;
        comments.forEach((comment: any, index: any) => {
            if ((comment.employee.user.id != this.note.employee.user.id) ||
                comment.employeeModified &&
                (comment.employeeModified.user.id != this.note.employee.user.id)) {
                return onlyMyComments = false;
            }
            // if (index == comments.length-1) {
            //     return onlyMyComments; 
            // }
        });
        return onlyMyComments;
    }

    private checkCommentUser(userId: any) {
        if (userId == this.employeeId) {
            return true;
        } else {
            return false;
        }
    }

    get avatar() {
        let avatar = this.assets.defaultAvatar;
        if (
            this.note.employee &&
            this.note.employee.user &&
            this.note.employee.user.profile &&
            this.note.employee.user.profile.avatar !== null
        ) {
            avatar = this.note.employee.user.profile.avatar;
        }
        return avatar;
    }

    get notificationsOptions() {
        const options: { id: any; name: any; }[] = [];
        this.employeeList = this.fetchEmployeeList(({
            search: '',
            limit: -1,
        })).then(function (response: any) {
            // console.log(response);
            for (const employee in response.results) {
                if (Number(employee) >= 0) {
                    options.push({
                        id: response.results[employee]['user']['id'],
                        name: response.results[employee]['user']['fullName'],
                    });
                    // console.log(options);
                }
            }
        });

        // console.log(this.employeeList);

        return options;
    }

    private sendNotifications(id: any) {
        this.employeeList = this.fetchEmployeeList(({
            search: '',
            limit: -1,
        }));
    }

    private deleteCommentNote(commentId: string) {
        // console.log(commentId);
        const payload = {
            elementId: this.elementId,
            noteId: this.noteId,
            commentId,
        };
        this.$store.dispatch('removeBudgetCommentNote', payload)
            .then((res: any) => {
                this.$emit('comment-note-item-delete');
            });
    }


    private emitDelete() {
        this.$emit('note-item-delete', this.note.id);
    }

    private emitNote() {
        this.$emit('note-item-new', this.note.id, this.note.type);
    }
}

